import { register } from '../../../../Javascript/Sysmex/Utils'
import { fetchUrls } from './Constants.async'

const MultiDownload = el => {
  const documentList = el.closest('[data-component="DocumentList"]')
  if (!documentList) return

  const prefix = el.dataset.prefix
  const downloadItems = documentList.querySelectorAll('.watchlist-download-card')
  const clearButton = el.querySelector(`.${prefix}clear-button--confirm`)
  const clearButtonCancel = el.querySelector(`.${prefix}clear-button--cancel`)
  const clearButtonAll = el.querySelector(`.${prefix}clear-button--all`)
  const toggler = el.querySelector(`.${prefix}toggler`)
  const downloadButtonAll = el.querySelector(`.${prefix}download-button--all`)
  const count = el.querySelector(`.${prefix}count`)
  const confirmationPopup = el.querySelector(`.${prefix}confirmationPopup`)
  const watchlist = el.querySelector(`.${prefix}item-list`)
  const elementTemplate = el.querySelector(`.${prefix}watchlist-template`)
  let isDropdownOpen = false

  // let showDropdown = false

  const init = () => {
    updateData()
    addEventListeners()
  }

  const addEventListeners = () => {
    downloadItems.forEach(item => {
      const addButton = item.querySelector('.watchlist-add-button')
      const removeButton = item.querySelector('.watchlist-remove-button')

      addButton.addEventListener('click', e => updateSingleItem(item))
      removeButton.addEventListener('click', e => updateSingleItem(item, false))
    })
    clearButton.addEventListener('click', clearAll)
    clearButtonAll.addEventListener('click', e => togglePopup(true))
    clearButtonCancel.addEventListener('click', e => togglePopup(false))
    toggler.addEventListener('click', toggleDropdown)
    downloadButtonAll.addEventListener('click', clickDownloadButton)
  }

  const toggleDropdown = () => {
    el.classList.toggle(`${prefix}open`)
    isDropdownOpen = !isDropdownOpen
    toggler.setAttribute('aria-expanded', isDropdownOpen.toString())
  }

  const updateSingleItem = (item, add = true, shouldUpdate = true, guid) => {
    if (item) {
      const addButton = item.querySelector('.watchlist-add-button')
      const removeButton = item.querySelector('.watchlist-remove-button')

      addButton.classList.toggle('hidden', add)
      removeButton.classList.toggle('hidden', !add)
    }

    if (shouldUpdate) updateData(add ? 'add' : 'remove', item?.dataset?.guid || guid)
  }

  const togglePopup = (show = true) => {
    confirmationPopup.classList.toggle('hidden', !show)
    clearButtonAll.classList.toggle('hidden', show)
  }

  const clearAll = () => {
    updateData('clear')
    togglePopup(false)
    downloadItems.forEach(item => updateSingleItem(item, false, false))
  }

  const rebuildList = (items) => {
    watchlist.innerHTML = ''

    Object.values(items).forEach(item => {
      watchlist.appendChild(buildListItem(item))
    })

    const itemsCount = Object.keys(items).length
    count.textContent = `[${itemsCount}]`
    toggler.disabled = !itemsCount

    if (!itemsCount) {
      el.classList.toggle(`${prefix}open`, itemsCount)
    }
  }

  const buildListItem = (item) => {
    const matchingCardElement = documentList.querySelector(`[data-guid="${item.guid}"]`)
    const newElement = elementTemplate.content.cloneNode(true)
    const deleteButton = newElement.querySelector(`.${prefix}delete-icon`)
    const titleContainer = newElement.querySelector(`.${prefix}title`)
    titleContainer.textContent = item.title
    deleteButton.addEventListener('click', () => updateSingleItem(matchingCardElement, false, true, item.guid))
    return newElement
  }

  const fetchData = async (url) => {
    const resp = await fetch(`?${url}`) // eslint-disable-line no-undef
    const respJSON = await resp.json()
    return respJSON.data
  }

  const updateData = (type = 'get', guid) => {
    fetchData(`${fetchUrls[type]}${guid || ''}`)
      .then(res => rebuildList(res))
      .catch(err => console.error(err))
  }

  const clickDownloadButton = e => {
    e.preventDefault()
    downloadFile(downloadButtonAll.href, 'Documents.zip')
    toggleDropdown()
  }

  const downloadFile = (url, filename) => {
    if (window.showGlobalLoader) window.dispatchEvent(window.showGlobalLoader)
    fetch(url, { // eslint-disable-line no-undef
      mode: 'no-cors'
    }).then((transfer) => {
      return transfer.blob()
    }).then((bytes) => {
      const ghostLink = document.createElement('a')
      ghostLink.href = URL.createObjectURL(bytes)
      ghostLink.setAttribute('download', filename)
      ghostLink.click()
      if (window.hideGlobalLoader) window.dispatchEvent(window.hideGlobalLoader)
    }).catch((err) => {
      if (window.hideGlobalLoader) window.dispatchEvent(window.hideGlobalLoader)
      console.error(err)
    })
  }

  init()
}

register('MultiDownload', MultiDownload)
